import React from 'react';

const PendingBadge = () => (
  <span className="px-2 py-0.5 rounded text-xs font-medium text-orange-800 bg-orange-100">
    Pending
  </span>
);

export default PendingBadge; 